import Config from '@config'

import { LocalStorageService } from './LocalStorageService'

interface AuthServiceCredentials {
  accessToken: string | null
}

const accessTokenName = 'jwt'

export class AuthService {
  static setCredentials(credentials: AuthServiceCredentials) {
    LocalStorageService.setItem(accessTokenName, credentials.accessToken)
  }

  static getCredentials(): AuthServiceCredentials {
    if (Config.isDev && Config.accessToken) {
      return {
        accessToken: Config.accessToken,
      }
    }

    return {
      accessToken: LocalStorageService.getItem(accessTokenName),
    }
  }

  static isAuth(): boolean {
    try {
      const accessToken = AuthService.getCredentials()?.accessToken
      if (!accessToken) return false

      const parts = accessToken.split('.')
      if (parts.length !== 3) return false

      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      )

      const body = JSON.parse(jsonPayload)
      if (!body?.exp || typeof body.exp !== 'number') return false

      return body.exp * 1000 > Date.now()
    } catch (err: any) {
      console.warn('[AuthService] isAuth() parse error:', err)

      return false
    }
  }

  static clearCredentials() {
    LocalStorageService.setItem(accessTokenName, null)
  }
}
